<template>
  <mdb-container>
    <mdb-btn @click="addChain" color="indigo">{{
      $t("add_new_chain")
    }}</mdb-btn>
    <DataTableAG
      :columns="columns"
      :getcontentpath="getchainspath"
      jsonobject="chains"
      :buttonList="['Muokkaa']"
      v-on:pressed-button1="editChains"
      width="800px"
      height="750px"
    />
    <EditRetailerChain
      v-if="editRetailerModal"
      :modal-show="editRetailerModal"
      :name="name"
      :description="description"
      :id="id"
      :active="active"
      :add-chain-state="addChainState"
      :key="componentKey"
      v-on:modal-cancelled="editRetailerCancelled"
      v-on:modal-ok="editRetailerOk"
    />
  </mdb-container>
</template>

<script>
import EditRetailerChain from "@/components/EditRetailerChain.vue";
import DataTableAG from "@/components/DataTableAG.vue";
import { mdbBtn, mdbContainer } from "mdbvue";
export default {
  name: "l",
  components: {
    mdbBtn,
    mdbContainer,
    EditRetailerChain,
    DataTableAG,
  },
  methods: {
    loadingReady() {
      this.loadReady = true;
    },
    editRetailerCancelled() {
      this.editRetailerModal = false;
    },
    editRetailerOk() {
      this.editRetailerModal = false;
      this.componentKey += 1;
    },
    editChains(rowData) {
      this.id = rowData.id;
      this.name = rowData.name;
      this.description = rowData.description;
      this.active = rowData.active;
      this.addChainState = false;
      this.editRetailerModal = true;
    },
    addChain() {
      this.resetChainData();
      this.componentKey += 1;
      this.addChainState = true;
      this.editRetailerModal = true;
    },
    resetChainData() {
      this.id = 0;
      this.name = "";
      this.description = "";
      this.active = 1;
    },
  },
  data: () => ({
    loadReady: false,
    editRetailerModal: false,
    addChainState: false,
    componentKey: 0,
    id: 0,
    name: "",
    description: "",
    search: "",
    active: 1,
    getchainspath: "/1.0/front/retailers/chains",
    rows: [],
    columns: [
      {
        field: "id",
        headerName: "Id",
        width: 100,
        pinned: "left",
        sortable: true,
        filter: true,
        resizable: true,
      },
      {
        field: "name",
        headerName: "Ketjun nimi",
        width: 150,
        pinned: "left",
        sortable: true,
        filter: true,
        resizable: true,
      },
      {
        field: "description",
        headerName: "Ketjun kuvaus",
        width: 300,
        pinned: "left",
        sortable: true,
        filter: true,
        resizable: true,
      },
      {
        field: "active",
        headerName: "Voimassa",
        width: 100,
        pinned: "left",
        sortable: true,
        filter: true,
        resizable: true,
      },
    ],
  }),
  mounted() {},
};
</script>
